import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { add } from 'date-fns';
import { Typography, Link } from '../../shared';
import ModalWrapper from '../../shared/ModalWrapper';
import ButtonPrimary from '../../shared/ButtonPrimary';
import Checkbox from '../../shared/Checkbox/Checkbox';

import './NoticePopup.scss';

const STORAGE_KEY = 'notice-popup-show-after';

const NoticePopup = () => {
  const location = useLocation();

  const [open, setOpen] = useState<boolean>(false);
  const [shownInCurrentSession, setShownInCurrentSession] = useState<boolean>(false);
  const [doNotShowIn, setDoNotShowIn] = useState<boolean>(false);

  useEffect(() => {
    const showAfter = localStorage.getItem(STORAGE_KEY);

    const isTermsPage = window.location.pathname === '/terms';

    if ((!showAfter || Number(showAfter) < Date.now()) && !isTermsPage && !shownInCurrentSession) {
      setOpen(true);
    }
  }, [location.pathname, shownInCurrentSession]);

  const handleModalClose = useCallback(() => {
    // Popup should not be closable - only way to close it is to accept the terms
  }, []);

  const handleTermsAccepted = useCallback(() => {
    if (doNotShowIn) {
      const targetDate = add(new Date(), {
        days: 30,
      });

      localStorage.setItem(STORAGE_KEY, targetDate.getTime().toString());
    }

    setOpen(false);
    setShownInCurrentSession(true);
  }, [doNotShowIn]);

  const onDoNotShowInChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => setDoNotShowIn(event.target.checked),
    [],
  );

  return (
    <div className="nostra__alpha-popup__container">
      <ModalWrapper open={open} onClose={handleModalClose}>
        <div className="nostra__alpha-popup">
          <Typography variant="heading-sm" weight="bold">
            Notice
          </Typography>
          <div className="nostra__alpha-popup-divider-large" />
          <div className="nostra__alpha-popup-description">
            <Typography variant="body-md">
              Please note that this application is experimental and is used entirely at your own risk. We will not be
              liable to you for any damages or losses (including but not limited to loss of funds) arising out of or
              relating to your use of the application.
            </Typography>
            <br />
            <Typography variant="body-md">
              By clicking Agree, you confirm that you have read and understood this Notice, the{' '}
              <Link href="https://nostra.finance/terms" target="_blank">
                Terms & Conditions
              </Link>
              , and the <Link href="https://nostra.finance/disclaimer">Disclaimer</Link>.
            </Typography>
          </div>

          <div className="nostra__alpha-popup__terms">
            <Checkbox checked={doNotShowIn} onChange={onDoNotShowInChange} />
            <Typography variant="body-md">Don’t show this notice again for 30 days</Typography>
          </div>

          <div className="nostra__alpha-popup-action">
            <ButtonPrimary onClick={handleTermsAccepted} size="lg" fullWidth>
              <Typography variant="body-md" color="text-primary-darkbg">
                Agree
              </Typography>
            </ButtonPrimary>
          </div>
        </div>
      </ModalWrapper>
    </div>
  );
};
export default NoticePopup;
